import {PLATFORM_COLUMN, PLATFORM_COLUMN_ID} from './platform-columns';

import type {GroupMultipleOptions, GroupSingleOption, OptionTab} from '@pb/kit-component-modal-options';
import type {SearchTemplateColumn} from 'src/modules/advanced-search-result/typedef';

type Options = {
    columns: Record<string, string>, columnsMap: SearchTemplateColumn[], items: OptionTab[],
    allOptions: GroupSingleOption[], noSortColumns: string[],
};

const platformOption: GroupSingleOption = {
    hidden: false, defaultOption: false,
    option: {optionId: PLATFORM_COLUMN_ID, label: 'Platform', fixed: false, pinned: false},
};
const isSource = (id: string) => id === 'type' || id === 'status';

const replaceOptions = <T extends GroupSingleOption | GroupMultipleOptions>(
    options: T[],
): (T | GroupSingleOption)[] => {
    let added = false;
    return options.flatMap<T | GroupSingleOption>(option => {
        if (!('option' in option) || !isSource(option.option.optionId)) {
            return [option];
        }
        if (added) {
            return [];
        }
        added = true;
        return [platformOption];
    });
};

export const withPlatformColumnOptions = <T extends Options>(base: T, enabled: boolean): T => {
    if (!enabled) {
        return base;
    }
    const columns = Object.fromEntries(Object.entries(base.columns).filter(([code]) => code !== 'TYPE' &&
        code !== 'STATUS'));
    return {
        ...base,
        columns: {...columns, [PLATFORM_COLUMN]: PLATFORM_COLUMN_ID},
        columnsMap: [
            ...base.columnsMap.filter(({code}) => !isSource(code)),
            {code: PLATFORM_COLUMN_ID, name: 'Platform', required: false},
        ],
        noSortColumns: [...base.noSortColumns, PLATFORM_COLUMN_ID],
        allOptions: replaceOptions(base.allOptions),
        items: base.items.map(tab => ({
            ...tab,
            items: tab.items?.map(group => ({
                ...group,
                options: replaceOptions(group.options),
            })),
        })),
    };
};
